import {SearchMandantenQuery, useDeleteMandant, useSearchMandanten} from "../../client/hooks";
import {QueryClient, useMutation, useQueryClient} from "react-query";
import {useTranslation} from "react-i18next";
import {Mandant, MandantenListe} from "../../api";
import {MandantenFilter} from "../../components/mandanten/table/FilterTableMandanten";
import {useNavigate} from "react-router-dom";
import {permissions} from "../../permissions";
import {useUserMandant} from "../useUserMandant";

export const useMandantenHandling = () => {
    const {t: translation} = useTranslation('mandanten');
    const queryClient: QueryClient = useQueryClient();
    const navigate = useNavigate()
    const {isSystemUser, checkMandantAndHasOneOfPermissions} = useUserMandant();

    const deleteMandant: (mandantId: string) => Promise<Mandant> = useDeleteMandant();
    const searchMandanten: (query: SearchMandantenQuery) => Promise<MandantenListe> = useSearchMandanten();

    const deleteMandantMutation = useMutation(
        (mandantId: string): Promise<Mandant> => deleteMandant(mandantId),
        {
            onSuccess: async (_data: Mandant, mandantId: string) => {
                await queryClient.invalidateQueries(["mandanten", mandantId]);
                navigate("/mandanten");
            },
        }
    );

    const loadMandanten = async (params: any, filter: MandantenFilter): Promise<MandantenListe> => {
        const search: string | undefined = filter.search?.toLowerCase();
        const filtered: string | undefined = params.filtered ?? undefined;
        const page: number = params.page ?? 0;
        const limit: number = params.limit ?? 25;
        const sort: string | undefined = params.sort ?? undefined;

        return await searchMandanten({
            search: search,
            filtered: filtered,
            page: page,
            limit: limit,
            sort: sort,
        })
    }

    const canCreateMandantField = () => {
        return isSystemUser;
    }

    const canEditMandantField = (mandantId: string) => {
        return (
            isSystemUser ||
            checkMandantAndHasOneOfPermissions(mandantId,
            [
                permissions.mandanten.edit,
                permissions.mandanten.own_edit,
            ]
        ));
    }

    const getMandantIdByObject = (mandantObject: any) => {
        return typeof mandantObject === "string" ? mandantObject : (mandantObject as Mandant)?.id ?? "";
    }

    return {
        translation,
        deleteMandantMutation,
        loadMandanten,
        canEditMandantField,
        canCreateMandantField,
        getMandantIdByObject,
    }
}